import { ColorTheme } from './types';

const SVG_THEME_MAP = {
  '#1E88E5': 'primaryColor',
  '#43A047': 'secondaryColor',
  '#FB8C00': 'tertiaryColor',
  '#E53935': 'accentColor',
} as const;

type SVGThemeKey = keyof typeof SVG_THEME_MAP;

export class PatternSVGRenderer {
  private static svgCache = new Map<string, SVGElement>();

  static async load(url: string): Promise<SVGElement> {
    if (this.svgCache.has(url)) {
      return this.svgCache.get(url)!.cloneNode(true) as SVGElement;
    }

    const res = await fetch(url);
    const svgText = await res.text();

    const doc = new DOMParser().parseFromString(svgText, 'image/svg+xml');
    const svg = doc.documentElement as any;

    this.normalizeSVG(svg); // 🔥 critical

    this.svgCache.set(url, svg);

    return svg.cloneNode(true) as SVGElement;
  }

  static applyTheme(svg: SVGElement, theme: ColorTheme) {
    svg.querySelectorAll('[data-theme-key]').forEach((el) => {
      const key = el.getAttribute('data-theme-key') as keyof ColorTheme;
      const color = theme[key];

      if (!color) return;

      if (el.hasAttribute('fill')) {
        el.setAttribute('fill', color + '');
      }

      if (el.hasAttribute('stroke')) {
        el.setAttribute('stroke', color + '');
      }
    });
  }

  static normalizeSVG(svg: SVGElement) {
    svg.querySelectorAll('[fill]').forEach((el) => {
      const fill = el.getAttribute('fill')?.toUpperCase() as SVGThemeKey;

      if (fill && SVG_THEME_MAP[fill]) {
        el.setAttribute('data-theme-key', SVG_THEME_MAP[fill]);
      }
    });

    svg.querySelectorAll('[stroke]').forEach((el) => {
      const stroke = el.getAttribute('stroke')?.toUpperCase() as SVGThemeKey;

      if (stroke && SVG_THEME_MAP[stroke]) {
        el.setAttribute('data-theme-key', SVG_THEME_MAP[stroke]);
      }
    });
  }

  static updateTheme(svg: SVGElement, theme: ColorTheme) {
    this.applyTheme(svg, theme);
  }
}
